import React from "react";

export const NotaCotizacion = ({ formulario, setFormulario, hotelesOpciones, monedaActiva }) => {
    // Manejar cambios en el campo de texto
    const handleChange = (e) => {
        setFormulario({
            ...formulario,
            notaCoti: e.target.value,
        });
    };

    return (
        <>
            <textarea
                value={formulario.notaCoti || ""}
                onChange={handleChange}
                style={{
                    width: "100%",
                    height: "200px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    resize: "none",
                }}
                placeholder="Escribe la nota aquí..."
            ></textarea>
        </>
    );
};
